import styled from 'styled-components'

export const ContainerStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  width: 100%;
  max-width: 1760px;
  padding-left: 15px;
  padding-right: 15px;
  margin: 0 auto;
  flex-wrap: wrap;

  /* Child element styles
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
